'use strict';

const toDate = function () {
  return function toDate(input) {
    var date;

    if (angular.isNumber(input)) {
      date = new Date(input * 1000);
    } else if (angular.isString(input) && input.length === 8) {
      date = new Date(Number(input.slice(0, 4)), Number(input.slice(4, 6)) - 1, Number(input.slice(6, 8)));
    }

    return date;
  };
};

export default toDate;



// WEBPACK FOOTER //
// ./app/src/filters/to_date.js